import { GridFilterItem } from "@mui/x-data-grid-pro";

import { noValueNeededOperations } from "types";

export const isEmptyFilter = (filter: GridFilterItem) =>
  filter.value || noValueNeededOperations.includes(filter.operator as never);
